module.exports = __webpack_public_path__ + "static/media/loader.958b6dd4.gif";